// Fallback catalog for the two commercial plans (Free is informative-only and
// rendered directly in Pricing.vue). The live catalog comes from
// GET /momo/ecartpay/subscription-plans; these entries mirror its plan codes.

export const PLAN_SECTIONS = [
  {
    id: "monthly",
    plans: [
      {
        code: "unlimited_monthly",
        backendPlanCode: "unlimited_monthly",
        periodType: "monthly",
        name: "Unlimited",
        price: 11.99,
        priceOriginal: 21.99,
        tokens: 720,
        purchaseType: "subscription",
        badge: "",
        featured: true,
      },
    ],
  },
  {
    id: "annual",
    plans: [
      {
        code: "unlimited_annual",
        backendPlanCode: "unlimited_annual",
        periodType: "yearly",
        name: "Unlimited",
        price: 49.99,
        tokens: 720,
        purchaseType: "subscription",
        badge: "",
        featured: true,
      },
    ],
  },
];
